var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAssetOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.662 3.302a.523.523 0 0 0-.468.289L2.872 6.219h3.006l1.45-2.917H4.661Zm3.834 0L7.046 6.22h3.762l-1.36-2.917h-.952Zm2.106 0 1.361 2.917h3.174l-1.288-2.624a.523.523 0 0 0-.47-.293h-2.777Zm4.265 3.964H9.511v6.497l5.356-6.497Zm-6.402 6.493V7.266H3.13l5.335 6.493ZM3.259 3.12a1.57 1.57 0 0 1 1.403-.864h8.717c.599 0 1.146.34 1.41.878l1.658 3.378a.523.523 0 0 1-.066.563l-6.99 8.478a.523.523 0 0 1-.807 0L1.619 7.075a.523.523 0 0 1-.063-.568L3.259 3.12Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAssetOutlined);
export default __webpack_public_path__ + "static/media/critical-asset-outlined.c9a1f035022e4543ee85790f0f406052.svg";
export { ForwardRef as ReactComponent };